import React, { Component } from 'react';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { Form } from 'react-final-form';
import PropTypes from '../../../types';
import { Content } from '../../../infrastructure/content';
import EmailAddress from './EmailAddress';
import BusinessNumber from './BusinessNumber';
import PreferredContactMethod from './PreferredContactMethod';
import FocusHOC from '../../../components/FocusHOC';
import { checkEmptyFieldValue, onKeyPress } from '../../../utils';
import Submit from '../../../components/Submit';

class BusinessContactDetailsPage extends Component {
  constructor(props) {
    super(props);
    this.saveBusinessContactDetailsForm = this.saveBusinessContactDetailsForm.bind(this);
  }
  saveBusinessContactDetailsForm(data) {
    const businessUpdate = checkEmptyFieldValue(this.props.businessUpdateId)
      ? this.props.businessUpdateId
      : this.props.businessId;
    this.props.saveBusinessContactDetailsForm(data, businessUpdate);
  }

  render() {
    const { decorators, getBusinessData } = this.props;
    return (
      <Form
        onSubmit={this.saveBusinessContactDetailsForm}
        initialValues={getBusinessData}
        onKeyPress={onkeypress}
        decorators={decorators}
        render={({ handleSubmit, values }) => (
          <form onSubmit={handleSubmit} onKeyPress={onKeyPress}>
            <Content>
              {({ businessContactDetailsPageTitle = '' }) => (
                <PageHeading>{businessContactDetailsPageTitle}</PageHeading>
              )}
            </Content>
            <EmailAddress values={values} />
            <BusinessNumber values={values} />
            <PreferredContactMethod values={values} />
            <Submit />
          </form>
        )}
      />
    );
  }
}

BusinessContactDetailsPage.propTypes = {
  saveBusinessContactDetailsForm: PropTypes.func.isRequired
};

export default FocusHOC(BusinessContactDetailsPage);
